import React from "react";
import { FlameIcon } from "lucide-react";
const TOTAL = 100;
const LEFT = 7;
export function ScarcityBar() {
  const pct = (TOTAL - LEFT) / TOTAL * 100;
  return <div className="mx-auto mt-5 w-full max-w-xl" data-id="element-54" data-mp="2yy5nyvthfm87">
      <p className="flex items-center justify-center gap-1.5 text-center text-sm font-extrabold text-red-600" data-id="element-55" data-mp="2l44tie9kcldn">
        <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-56" data-mp="2q2g5aujf55yi" />
        Only {LEFT} spots left at the promotional price!
      </p>
      <div className="mt-2 h-5 w-full overflow-hidden rounded-full bg-red-100 ring-1 ring-red-200" role="progressbar" aria-valuenow={Math.round(pct)} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-57" data-mp="2b936bnyultdp">
        <div className="bar-stripes flex h-full items-center justify-end rounded-full bg-red-600 pr-2" style={{
        width: `${pct}%`
      }} data-id="element-58" data-mp="275ewszqnonpt">
          <span className="text-[11px] font-extrabold text-white" data-id="element-59" data-mp="5dibiyeorzhu">{Math.round(pct)}% claimed</span>
        </div>
      </div>
    </div>;
}